// 点検状態
export const INSPECTION_STATUS_MAP = {
    noAppointment: { code: 1, name: "アポ未実施" },
    appointment: { code: 2, name: "アポ実施済" },
    underInspection: { code: 3, name: "点検中" },
    newCreate: { code: 4, name: "新規作成" },
    cancel: { code: 5, name: "取り消し" },
    completed: { code: 6, name: "点検完了" }
};

// 点検種別
export const INSPECTION_TYPE_MAP = {
    hospitalMyCompany: { code: 0, name: "院内/当社点検有" },
    hospitalNoMyCompany: { code: 1, name: "院内/当社点検無し" },
    homeMyCompany: { code: 2, name: "在宅/当社点検" },
    homeDealer: { code: 3, name: "在宅/ディーラー点検" },
    RRUnnecessary: { code: 4, name: "院内・在宅/RR点検不要" },
    inCompanyDevice: { code: 5, name: "社内器" },
    freeMaintenance: { code: 6, name: "フリーメンテ" },
};

// 消耗品種別
export const DELIVERY_KIND_FLAG_MAP = {
    regular: { code: 1, name: "定期" },
    irregular: { code: 9, name: "非定期" },
};

// 印刷種別
export const PRINT_TYPE_MAP = {
    patient: { code: 1, name: "患者" },
    hospital: { code: 2, name: "医療機関" },
};

// 受け渡し種別
// code 1 ～ 3 は、患者、医療機関で同じ意味を持つ
export const SEND_TYPE_PATIENT_MAP = {
    hold: { code: 1, name: "手持ち" },
    send: { code: 2, name: "送付" },
    none: { code: 3, name: "点検報告書送付不要" },
};
export const SEND_TYPES_PATIENT = Object.values(SEND_TYPE_PATIENT_MAP);
export const SEND_TYPE_HOSPITAL_MAP = {
    hold: { code: 1, name: "手持ち" },
    send: { code: 2, name: "送付" },
    none: { code: 3, name: "N/A" },
    pcp: { code: 4, name: "PCP公開" },
    naviexp: { code: 5, name: "ナビエク郵送" },
};
export const SEND_TYPES_HOSPITAL = Object.values(SEND_TYPE_HOSPITAL_MAP);

// 印刷状態
export const PRINT_STATUS_MAP = {
    notOutput: { code: 2, name: "未出力" },
    outputed: { code: 1, name: "印刷済" },
    confirmed: { code: 3, name: "確認済" },
    outputedPcp: { code: 4, name: "PCP公開済" },
    outputedNaviexp: { code: 5, name: "ナビエク郵送済" },
    viewed: { code: 6, name: "PCP閲覧済" },
};

export const TRILOGY_EVO_SETTING = [
    { code: 0, contentsType: 1, stContentsType: "1", name: "【設定1】" },
    { code: 1, contentsType: 2, stContentsType: "2", name: "【設定2】" },
    { code: 2, contentsType: 3, stContentsType: "3", name: "【設定3】" },
    { code: 3, contentsType: 4, stContentsType: "4", name: "【設定4】" },
    { code: 4, contentsType: 5, stContentsType: "5", name: "【設定5】" },
];

export const MACHINE_TYPE = {
    "A40": {
        code: 1,
        value: "A40"
    },
    "BiPAP": {
        code: 2,
        value: "BiPAP"
    },
    "LTV": {
        code: 3,
        value: "LTV"
    },
    "COUGH_ASSIST": {
        code: 4,
        value: "カフアシスト"
    },
    "TRILOGY": {
        code: 5,
        value: "トリロジー"
    },
    "HOT": {
        code: 6,
        value: "酸素濃縮器（HOT）"
    },
    "TRILOGY_EVO": {
        code: 7,
        value: "トリロジーEvo"
    },
    "PRISMA": {
        code: 8,
        value: "プリズマVENT50"
    },
    "INSPIRED_FLO": {
        code: 9,
        value: "Inspireフロー"
    },
    "A40Pro": {
        code: 10,
        value: "A40Pro"
    },
    "COUGH_ASSIST2": {
        code: 11,
        value: "COUGH_ASSIST2"
    },
    "ASV": {
        code: 13,
        value: "ASV"
    },
    "LUISA": {
        code: 12,
        value: "LUISA"
    },
    "CW2": {
        code: 17,
        value: "クリアウェイ2"
    },
    "myAIRVO2": {
        code: 18,
        value: "myAIRVO2"
    },
};

/**
 * 点検入力画面 見出し
 * key1: reportFormatType
 * key2: contentsType
 * key3: displayOrder
 * 
 * ※トリロジーEvo以外は個別に実装されているため、定義は空
 */
export const INSPECTION_HEADER = {};
const HEADER1_COLOR = "#0e5dd3";
const HEADER2_COLOR = "#209cee";
INSPECTION_HEADER[MACHINE_TYPE.A40.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.BiPAP.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.LTV.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.COUGH_ASSIST.code] = {
    "1": {},  // 設定1
    "2": {},  // 設定2
    "3": {},  // 設定3
};
INSPECTION_HEADER[MACHINE_TYPE.TRILOGY.code] = {
    "1": {},  // 設定1
    "2": {},  // 設定2
};
INSPECTION_HEADER[MACHINE_TYPE.HOT.code] = {
    "1": {},  // 設定1
    "2": {},  // 設定2
    "3": {},  // 設定3
    "4": {},  // 設定4
    "5": {},  // 設定5
    "6": {},  // 設定6
};
INSPECTION_HEADER[MACHINE_TYPE.TRILOGY_EVO.code] = {
    "1": {  // 設定1
        "19": [  // AVAPS
            {
                headerName: "量規定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "30": [  // 回路タイプ
            {
                headerName: "呼吸回路選択",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "33": [  // 無呼吸　Backup（PSV/CPAP）
            {
                headerName: "追加設定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "40": [  // 吸気圧アラーム（最小）
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "51": [  // アラーム音量
            {
                headerName: "オプション",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "60": [  // 本体SpO2オプション（無/有）
            {
                headerName: "SpO2",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "65": [  // ソフトウェアバージョン
            {
                headerName: "点検項目（※非装着時点検項目）",
                backgroundColor: HEADER1_COLOR
            }
        ],
        "76": [  // 点検時の状態
            {
                headerName: "測定表示値",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "83": [  // 回路外れ時（患者接続部を大気解放しアラーム発生を確認する）※
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "87": [  // 日時設定のずれ
            {
                headerName: "使用状況",
                backgroundColor: HEADER2_COLOR
            }
        ],
    },
    "2": {  // 設定2
        "138": [  // AVAPS
            {
                headerName: "量規定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "149": [  // 回路タイプ
            {
                headerName: "呼吸回路選択",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "152": [  // 無呼吸　Backup（PSV/CPAP）
            {
                headerName: "追加設定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "159": [  // 吸気圧アラーム（最小）
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "170": [  // 本体SpO2オプション（無/有）
            {
                headerName: "SpO2",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "175": [  // 点検時の状態
            {
                headerName: "点検項目（※非装着時点検項目）",
                backgroundColor: HEADER1_COLOR
            },
            {  // 点検時の状態
                headerName: "測定表示値",
                backgroundColor: HEADER2_COLOR
            },
        ],
        "182": [  // SpO2モニタ〔測定値：　　%〕
            {
                headerName: "使用状況",
                backgroundColor: HEADER2_COLOR
            }
        ],
    },
    "3": {  // 設定3
        "203": [  // AVAPS
            {
                headerName: "量規定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "214": [  // 回路タイプ
            {
                headerName: "呼吸回路選択",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "217": [  // 無呼吸　Backup（PSV/CPAP）
            {
                headerName: "追加設定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "224": [  // 吸気圧アラーム（最小）
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "235": [  // 本体SpO2オプション（無/有）
            {
                headerName: "SpO2",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "240": [  // 点検時の状態
            {
                headerName: "点検項目（※非装着時点検項目）",
                backgroundColor: HEADER1_COLOR
            },
            {
                headerName: "測定表示値",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "247": [  // SpO2モニタ〔測定値：　　%〕
            {
                headerName: "使用状況",
                backgroundColor: HEADER2_COLOR
            }
        ],
    },
    "4": {  // 設定4
        "268": [  // AVAPS
            {
                headerName: "量規定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "279": [  // 回路タイプ
            {
                headerName: "呼吸回路選択",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "282": [  // 無呼吸　Backup（PSV/CPAP）
            {
                headerName: "追加設定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "289": [  // 吸気圧アラーム（最小）
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "300": [  // 本体SpO2オプション（無/有）
            {
                headerName: "SpO2",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "305": [  // 点検時の状態
            {
                headerName: "点検項目（※非装着時点検項目）",
                backgroundColor: HEADER1_COLOR
            },
            {  // 点検時の状態
                headerName: "測定表示値",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "312": [  // SpO2モニタ〔測定値：　　%〕
            {
                headerName: "使用状況",
                backgroundColor: HEADER2_COLOR
            }
        ],
    },
    "5": {  // 設定5
        "333": [  // AVAPS
            {
                headerName: "量規定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "344": [  // 回路タイプ
            {
                headerName: "呼吸回路選択",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "347": [  // 無呼吸　Backup（PSV/CPAP）
            {
                headerName: "追加設定",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "354": [  // 吸気圧アラーム（最小）
            {
                headerName: "アラーム",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "365": [  // 本体SpO2オプション（無/有）
            {
                headerName: "SpO2",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "370": [  // 点検時の状態
            {
                headerName: "点検項目（※非装着時点検項目）",
                backgroundColor: HEADER1_COLOR
            },
            {  // 点検時の状態
                headerName: "測定表示値",
                backgroundColor: HEADER2_COLOR
            }
        ],
        "377": [  // SpO2モニタ〔測定値：　　%〕
            {
                headerName: "使用状況",
                backgroundColor: HEADER2_COLOR
            }
        ],
    },
};
INSPECTION_HEADER[MACHINE_TYPE.PRISMA.code] = {
    "1": {},  // prog1
    "2": {},  // prog2
    "3": {},  // prog3
};
INSPECTION_HEADER[MACHINE_TYPE.INSPIRED_FLO.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.A40Pro.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.COUGH_ASSIST2.code] = {
    "1": {},  // プリセット1
    "2": {},  // プリセット2
    "3": {},  // プリセット3
    "4": {},  // プリセット4
    "5": {},  // プリセット5
    "6": {},  // プリセット6
    "7": {},  // プリセット7
    "8": {},  // プリセット8
    "9": {},  // プリセット9
};
INSPECTION_HEADER[MACHINE_TYPE.LUISA.code] = {
    "1": {},  // 主設定
    "2": {},  // プログラム1
    "3": {},  // プログラム2
    "4": {},  // プログラム3
    "5": {},  // プログラム4
};
INSPECTION_HEADER[MACHINE_TYPE.ASV.code] = {
    "1": {},  // 設定1
};
INSPECTION_HEADER[MACHINE_TYPE.CW2.code] = {
    "1": {},  // 主設定
    "2": {},  // プロファイル1
    "3": {},  // プロファイル2
    "4": {},  // プロファイル3
    "5": {},  // プロファイル4
};
INSPECTION_HEADER[MACHINE_TYPE.myAIRVO2.code] = {
    "1": {},  // 設定1
};

/**
 * 処方値修正、処方値参照、点検値参照画面 見出し
 * 「点検入力画面 見出し」を複写して、固有情報を追加
 * key1: reportFormatType
 * key2: hardwareVersion
 * key3: contentsType
 * key4: displayOrder
 */
export const INSPECTION_HEADER_FULL = JSON.parse(JSON.stringify(INSPECTION_HEADER));

export function getMainSettingTrilogyEvo(mainSetting, contentsType) {
    let prefix = "　";
    if (mainSetting != null) {
        // 起点（contentsType = 1、mainSetting = 0）
        if (contentsType - 1 == mainSetting) {
            prefix = "メイン設定";
        }
    }
    return prefix;
}
function getHardwareVersionTrilogyEvo(inspectionItems) {
    let hardwareVersion = 0;
    const findItemV1 = inspectionItems.find((elem) => elem.displayName.indexOf("画面順番") != -1);
    if (findItemV1) {
        hardwareVersion = 1;
    }
    
    return hardwareVersion;
}
function getHiddenNotSapTrilogyEvo(inspectionItems) {
    let hiddenNotSap = false;
    let hardwareVersion = getHardwareVersionTrilogyEvo(inspectionItems);
    if (hardwareVersion > 0) {
        hiddenNotSap = true;
    }
    return hiddenNotSap;
}

const INSPECTION_HEADER_FULL_TRILOGY_EVO_V1 = INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code];
INSPECTION_HEADER_FULL_TRILOGY_EVO_V1["1"]["1"] =
    [  // 設定1
        {
            getPrefix: getMainSettingTrilogyEvo,
            headerName: TRILOGY_EVO_SETTING[0].name,
            backgroundColor: HEADER1_COLOR
        }
    ];
INSPECTION_HEADER_FULL_TRILOGY_EVO_V1["2"]["121"] =
    [  // 設定2
        {
            getPrefix: getMainSettingTrilogyEvo,
            headerName: TRILOGY_EVO_SETTING[1].name,
            backgroundColor: HEADER1_COLOR
        }
    ];
INSPECTION_HEADER_FULL_TRILOGY_EVO_V1["3"]["186"] =
    [  // 設定3
        {
            getPrefix: getMainSettingTrilogyEvo,
            headerName: TRILOGY_EVO_SETTING[2].name,
            backgroundColor: HEADER1_COLOR
        }
    ];
INSPECTION_HEADER_FULL_TRILOGY_EVO_V1["4"]["251"] =
    [  // 設定4
        {
            getPrefix: getMainSettingTrilogyEvo,
            headerName: TRILOGY_EVO_SETTING[3].name,
            backgroundColor: HEADER1_COLOR
        }
    ];
INSPECTION_HEADER_FULL_TRILOGY_EVO_V1["5"]["316"] =
    [  // 設定5
        {
            getPrefix: getMainSettingTrilogyEvo,
            headerName: TRILOGY_EVO_SETTING[4].name,
            backgroundColor: HEADER1_COLOR
        }
    ];

const INSPECTION_HEADER_FULL_TRILOGY_EVO_V0 = {
    "1": {},    // 設定1
    "2": {},    // 設定2
    "3": {},    // 設定3
    "4": {},    // 設定4
    "5": {},    // 設定5
    "6": {},    // 設定5
};

INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code] = {};
INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code].getHardwareVersion = getHardwareVersionTrilogyEvo;
INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code].getHiddenNotSap = getHiddenNotSapTrilogyEvo;
INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code]["0"] = INSPECTION_HEADER_FULL_TRILOGY_EVO_V0;
INSPECTION_HEADER_FULL[MACHINE_TYPE.TRILOGY_EVO.code]["1"] = INSPECTION_HEADER_FULL_TRILOGY_EVO_V1;

/**
 * シリアル読み取り
 * 読み取ったシリアルや品目コードの設定位置を定義
 * key1: reportFormatType
 * key2: 項目名
 * displayOrder: シリアル読み取り項目のindexからの位置
 */
export const SERIAL_CHANGED_INDEX = {};
SERIAL_CHANGED_INDEX[MACHINE_TYPE.TRILOGY_EVO.code] = [
    { // 品目コード
        key: "productCode",
        displayOrder: -2,
    },
    { // 品目名
        key: "productName",
        displayOrder: -1,
    },
    { // シリアル
        key: "serialCode",
        displayOrder: 0,
    },
];



// WEBPACK FOOTER //
// ./src/utils/inspection.js